import axios from 'axios'
import { merge } from 'lodash'
import * as Auth from '../auth/auth'
import * as ApiConf from '../../config/api'
// import * as Types from '../../types'
import { AdditionalItem } from '../../types/AdditionalItem'
import ApiError from '../../Errors/ApiError'
import { TIMEOUT } from '../../constants/timeout'
import {
    Job,
    Bid,
    Slots,
    Preference,
    JobRequestType,
    Rating,
    AttachmentCreate,
    AttachmentCreateResponse,
    AttachmentParams,
    ClientInfo,
    Enums,
    Compliment
} from '../../types'
import { ContactUs } from '../../localization/ContactUs'
import { ContactUsParams, ContactUsType } from '../../types/ContactUs'
import { PreferenceType } from '../../types/enums/PreferenceType'
import { ErrorInformation } from '../../types/Errors/ErrorInformation'
import { store } from '../../index'
import { lastReduxActions } from '../../store/configureStore'
import * as moment from 'moment'

export enum Method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT'
}

interface ApiErrorResponse {
    code: string
    description: string
}

// TODO: this is simple stub probably should be replaced in future
export class Api {
    static async sendIssue(message: string, issueInfo: ContactUsParams) {
        let path = `/clients/to_support`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.EMAIL_SERVICES
        )
        let AttachObj = {
            text: JSON.stringify(message),
            info: issueInfo
        }

        console.log(AttachObj)

        return this.authCall<any>(
            `${endpoint}${path}`,
            Method.POST,
            {},
            AttachObj
        )
    }

    static async getMsaByZip(zip: string): Promise<any> {
        let path = `/msa/by_zip/${zip}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.MSA_SERVICE
        )
        return this.call<any>(`${endpoint}${path}`, Method.GET)
    }

    static async getClientInfo(): Promise<ClientInfo> {
        let path = `/clients`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.CLIENT_SERVICE
        )
        return this.authCall<ClientInfo>(`${endpoint}${path}`)
    }

    static async setClientInfo(clientInfo: ClientInfo) {
        let path = `/clients`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.CLIENT_SERVICE
        )
        return this.authCall<any>(
            `${endpoint}${path}`,
            Method.PUT,
            {},
            clientInfo
        )
    }

    static async createClient(clientInfo: any): Promise<any> {
        // todo set types
        let path = `/clients`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.CLIENT_SERVICE
        )
        return this.call<any>(`${endpoint}${path}`, Method.POST, {}, clientInfo)
    }

    static async getAvatarId(authToken: string, ownerId: string): Promise<any> {
        const path = `/attachments`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.ATTACHMENT_SERVICE
        )

        let attachmentObj = {
            type: 'AVATAR_PICTURE',
            ownerId: ownerId,
            overwrite: true
        }
        const options = {
            headers: {
                Authorization: authToken
            }
        }
        return this.call<any>(
            `${endpoint}${path}`,
            Method.POST,
            options,
            attachmentObj
        )
    }

    static async getAvatarIdAuthorized(ownerId: string): Promise<any> {
        const path = `/attachments`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.ATTACHMENT_SERVICE
        )

        let attachmentObj = {
            type: 'AVATAR_PICTURE',
            ownerId: ownerId,
            overwrite: true
        }
        return this.authCall<any>(
            `${endpoint}${path}`,
            Method.POST,
            {},
            attachmentObj
        )
    }

    static async sendStripeToken(stripeToken: string, idToken: string) {
        let path = '/payment-service/client-account'
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.PAYMENT_SERVICE
        )

        let options = {
            headers: {
                Authorization: idToken
            }
        }

        let data = {
            paymentToken: stripeToken,
            description: ''
        }

        return this.call<any>(`${endpoint}${path}`, Method.PUT, options, data)
    }

    static async sendStripeTokenAuthorized(stripeToken: string) {
        let path = '/payment-service/client-account'
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.PAYMENT_SERVICE
        )

        let data = {
            paymentToken: stripeToken,
            description: ''
        }
        return this.authCall<any>(`${endpoint}${path}`, Method.PUT, {}, data)
    }

    static async getBidsForJob(jobId: string) {
        let path = `/bids/jobs/${jobId}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.BIDDING_SERVICE
        )
        return this.authCall<Bid[]>(`${endpoint}${path}`)
    }

    static async uploadImage(attachment: AttachmentParams, uri: string) {
        console.log('Start upload image')
        let path = attachment.url
        const blob = await this.call(uri, Method.GET, { responseType: 'blob' })
        return this.call(
            path,
            Method.PUT,
            { headers: { 'Content-Type': ' ' } },
            blob
        )
    }

    public static async createAttachment(
        attachmentOwnerInfo: AttachmentCreate
    ): Promise<AttachmentCreateResponse> {
        let path = '/attachments'
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.ATTACHMENT_SERVICE
        )
        return this.authCall<AttachmentCreateResponse>(
            `${endpoint}${path}`,
            Method.POST,
            {},
            attachmentOwnerInfo
        )
    }

    static async acceptBid(jobId: string, haulerId: string) {
        let path = `/bids/accept/jobs/${jobId}/haulers/${haulerId}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.BIDDING_SERVICE
        )
        return this.authCall(`${endpoint}${path}`, Method.PUT)
    }

    static async getJob(id: string) {
        let path = `/jobs/${id}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getCategories() {
        let path = `/job_categories`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getActiveJobs() {
        let path = `/clients/self/jobs`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getCompletedJobs() {
        let path = `/clients/self/jobs/completed`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getCategoriesByZipCode(zipCode?: string) {
        let path = `/job_categories/by_zip/${zipCode}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getImageId(): Promise<AttachmentParams> {
        let path = `/attachments`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.ATTACHMENT_SERVICE
        )
        let attachObj = {
            type: Enums.AttachmentType.JOB_PICTURE,
            ownerId: ''
        }
        return this.authCall<AttachmentParams>(
            `${endpoint}${path}`,
            Method.POST,
            {},
            attachObj
        )
    }

    static async setOwnerId(attachment: any, ownerId: any) {
        console.log(attachment, ownerId)
        let path = `/attachments/UNATTACHED_ID/${attachment.id}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.ATTACHMENT_SERVICE
        )
        let attachObj = {
            type: Enums.AttachmentType.JOB_PICTURE,
            ownerId: ownerId
        }
        return this.authCall(`${endpoint}${path}`, Method.PUT, {}, attachObj)
    }

    static async newJob(job: any) {
        let path = `/jobs/`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, job)
    }
    static async repostJob(id: number, timeSlots: Slots[]) {
        let path = `/jobs/repost`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(
            `${endpoint}${path}`,
            Method.POST,
            {},
            { id, timeSlots }
        )
    }

    static async changeStatus(id: string, status: string) {
        let path = `/jobs/change_status/${id}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        let attachObj = {
            status: status
        }
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, attachObj)
    }

    static async submitRating(rating: Rating) {
        let path = `/ratings/client`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.RATING_SERVICE
        )
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, rating)
    }

    static async getTagsRating(): Promise<string[]> {
        let path = `/ratings/message/client`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.RATING_SERVICE
        )
        return this.authCall<string[]>(`${endpoint}${path}`)
    }

    static async requestAdditionalItem(
        jobId: string,
        additionalItem: AdditionalItem
    ) {
        let path = `/jobs/additional_payment/accepting`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        let attachObj = {
            id: jobId,
            additionalItem
        }
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, attachObj)
    }

    static async getPreference(id: PreferenceType): Promise<Preference> {
        const path = `/preferences/${id}`
        const endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.PREFERENCES_SERVICE
        )

        return this.authCall<Preference>(`${endpoint}${path}`, Method.GET)
    }

    static async getTerms() {
        let path = `/documents/client`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.MSA_SERVICE
        )
        return this.authCall(`${endpoint}${path}`, Method.GET)
    }

    static async acceptTerms(id: string) {
        let path = `/documents/client/accept`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.MSA_SERVICE
        )
        let attachObj = [
            {
                id: id
            }
        ]
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, attachObj)
    }

    // TODO: delete
    static async getCompliments(): Promise<Compliment[]> {
        return [
            { title: 'Amazing effort', id: '1' },
            { title: 'Thank you for being timely', id: '2' },
            { title: 'Excellent service', id: '3' },
            { title: 'Very professional', id: '4' }
        ]
    }

    static async getFee(jobId: string): Promise<any> {
        let path = `/job/calc_cancellation_fee/client/${jobId}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_SERVICE
        )
        return this.authCall(`${endpoint}${path}`)
    }

    static async getTwilioToken(): Promise<string> {
        let path = '/token'
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.MESSAGING_SERVICE
        )
        return this.authCall<string>(`${endpoint}${path}`, Method.GET)
    }

    static async sendOptIn(
        isSmsOptedIn: boolean,
        isEmailOptedIn: boolean = true
    ) {
        let path = `/client/optins`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.DISPATCHER_SERVICE
        )
        let data = {
            isSmsOptedIn,
            isEmailOptedIn
        }
        return this.authCall<string>(`${endpoint}${path}`, Method.PUT, {}, data)
    }

    static async logError(information: ErrorInformation) {
        information.application = 'Web client'
        information.state = store.getState()
        information.lastActions = lastReduxActions
        let path = '/log'
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.LOG_SERVICE
        )

        try {
            await this.authCall(
                `${endpoint}${path}`,
                Method.POST,
                {},
                information
            )
        } catch (error) {
            console.error(error)
        }
    }

    static async createJobRequest(jobRequest: JobRequestType) {
        let path = `/job-request`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_REQUEST_SERVICE
        )

        // const options = {
        //     method: 'POST',
        //     body: JSON.stringify(jobRequest)
        // };

        return this.authCall(`${endpoint}${path}`, Method.POST, {}, jobRequest)
    }

    static async updateJobRequest(id: string, jobRequest: JobRequestType) {
        let path = `/job-request/${id}`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_REQUEST_SERVICE
        )

        // const options = {
        //     method: 'POST',
        //     body: JSON.stringify(jobRequest)
        // };
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, jobRequest)
    }

    static async deleteJobRequest(id: string) {
        let path = `/job-request/${id}/delete`
        let endpoint = ApiConf.ENDPOINTS_MAP.get(
            ApiConf.EndpointNames.JOB_REQUEST_SERVICE
        )

        // const options = {
        //     method: 'POST'
        // };
        return this.authCall(`${endpoint}${path}`, Method.POST, {}, {})
    }

    private static async call<T>(
        url: string,
        method: Method = Method.GET,
        options = {},
        data: any | null = null
    ) {
        let callConfig = merge(
            {
                url: url,
                method: method,
                data: data,
                headers: {
                    'GT2-AppVersion': '4.2.6',
                    'GT2-DeviceId': window.navigator.userAgent,
                    'GT2-TimeZone': moment().utcOffset()
                }
            },
            options
        )
        try {
            return await axios(callConfig).then(result => {
                return result.data as T
            })
        } catch (error) {
            let respError = error.response.data.error as ApiErrorResponse
            throw new ApiError(
                error.response.status,
                respError.code,
                respError.description
            )
        }
    }

    private static async authCall<T>(
        url: string,
        method: Method = Method.GET,
        options = {},
        data: any | null = null
    ): Promise<T> {
        let token = await Auth.getCurrentToken()
        let callConfig = merge(
            {
                url: url,
                method: method,
                timeout: TIMEOUT,
                data: data,
                headers: {
                    Authorization: token,
                    'GT2-AppVersion': '4.2.6',
                    'GT2-DeviceId': window.navigator.userAgent,
                    'GT2-TimeZone': moment().utcOffset()
                }
            },
            options
        )
        try {
            return await axios(callConfig).then(result => {
                return result.data as T
            })
        } catch (error) {
            if (error.response && error.response.status === 401) {
                // Token shoud be refreshed
                token = await Auth.getCurrentToken()
                callConfig.headers.Authorization = token
                return axios(callConfig).then(result => {
                    return result.data as T
                })
            }
            let respError =
                error.response &&
                (error.response.data.error as ApiErrorResponse)
            throw new ApiError(
                error.response.status,
                respError.code,
                respError.description
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/api/api.ts